var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetGreet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-meet_greet",
    width: 24,
    height: 24,
    viewBox: "2 2 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8C3 6.34315 4.34315 5 6 5H18C19.6569 5 21 6.34315 21 8V17C21 18.6569 19.6569 20 18 20H6C4.34315 20 3 18.6569 3 17V8ZM6 6.5H18C18.8284 6.5 19.5 7.17157 19.5 8V17C19.5 17.8284 18.8284 18.5 18 18.5H14.25V12.8C14.7 12.65 15.15 12.425 15.525 12.125C16.65 11.225 17.175 9.95 17.25 8.3V8H15.75V8.375C15.75 9.5 15.36 10.355 14.61 10.955C14.01 11.405 13.5 11.75 12 11.75C10.5 11.75 9.1575 12.3575 8.3325 13.0325C7.2825 13.9325 6.75 15.125 6.75 16.625V17H8.25V16.625C8.2575 15.5 8.625 14.825 9.3 14.3C9.375 14.225 9.525 14.15 9.75 14.075V18.5H6C5.17157 18.5 4.5 17.8284 4.5 17V8C4.5 7.17157 5.17157 6.5 6 6.5ZM10.5 9.5C10.5 10.325 11.175 11 12 11C12.825 11 13.5 10.325 13.5 9.5C13.5 8.675 12.825 8 12 8C11.175 8 10.5 8.675 10.5 9.5Z",
    fill: "#7E8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetGreet);
export default __webpack_public_path__ + "static/media/meetGreet.88fa382d.svg";
export { ForwardRef as ReactComponent };